module.exports = __webpack_public_path__ + "img/07.5859aab5.png";